import styles from "./ViewHotspotModal.module.css";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useAppStore } from "../../hooks/store/useAppStore";
import { showHotspotModalSelector, currentHotspotSelector } from "../../hooks/store/getters";
import { setShowHotspotModalSelector } from "../../hooks/store/setters";
import ViewHotspotAudio from './hotspot-audio/ViewHotspotAudio';
import ViewHotspotVideo from './hotspot-video/ViewHotspotVideo';
import ViewHotspotImage from './hotspot-image/ViewHotspotImage';

const ViewHotspotModal = () => {
  const showHotspotModal = useAppStore(showHotspotModalSelector);
  const setShowHotspotModal = useAppStore(setShowHotspotModalSelector);
  const currentHotspot = useAppStore(currentHotspotSelector);
  
  if (!currentHotspot) return null;
  
  const { name, description } = currentHotspot;
  
  return (
    <Modal
      show={showHotspotModal}
      onHide={() => setShowHotspotModal(false)}
      centered
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <span>Hotspot Details</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.hotspotDetails}>
          <Row>
            <ViewHotspotImage />
            
            <Col md={currentHotspot.image.url ? 6 : 10}>
              <div className={styles.hotspotDetailsForm}>
                <div className={styles.hotspotMedia}>
                  <ViewHotspotAudio />
                  <ViewHotspotVideo />
                </div>
                <h2>
                  {name}
                </h2>
                <p>
                  {description}
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ViewHotspotModal;
